<div class="toolbar-submenu-container">
  @if (notifications.length === 0) {
    <div class="empty-message">
      {{ i18n.i18nLng()['NONEWNOTIFICATIONS'] }}
    </div>
  } @else {
    <ul role="menu">
      @for (menuItem of menuItems; track menuItem.id) {
        <li role="none" class="mb-1">
          @if (menuItem?.command) {
            <ng-container>
              <a #menuLink
                 [pAutoFocus]="menuItem.autoFocus"
                 role="menuitem"
                 tabindex="0"
                 pRipple
                 class="toolbar-submenu-item gap-2"
                 [attr.aria-label]="i18n?.i18nLng()[menuItem.i18nLabelKey]"
                 (click)="commandItemClick($event, menuItem)"
                 (keydown.enter)="commandItemClick($event, menuItem)"
                 (keydown.space)="commandItemClick($event, menuItem)">
                <i [ngClass]="menuItem.icon"></i>
                <span>{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
              </a>
            </ng-container>
          }
          @if (menuItem?.routerLink) {
            <ng-container>
              <a #menuLink
                 [pAutoFocus]="menuItem.autoFocus"
                 role="menuitem"
                 tabindex="0"
                 pRipple
                 class="toolbar-submenu-item gap-2"
                 [attr.aria-label]="i18n?.i18nLng()[menuItem.i18nLabelKey]"
                 [routerLink]="menuItem.routerLink">
                <i [ngClass]="menuItem.icon"></i>
                <span>{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
              </a>
            </ng-container>
          }
          @if (menuItem?.url) {
            <ng-container>
              <a #menuLink
                 [pAutoFocus]="menuItem.autoFocus"
                 role="menuitem"
                 tabindex="0"
                 pRipple
                 class="toolbar-submenu-item gap-2"
                 [attr.aria-label]="i18n?.i18nLng()[menuItem.i18nLabelKey]"
                 [href]="menuItem?.url"
                 [target]="menuItem?.target ? menuItem?.target : null">
                <i [ngClass]="menuItem.icon"></i>
                <span>{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
              </a>
            </ng-container>
          }
          @if (!menuItem?.routerLink && !menuItem.command) {
            <ng-container>
              <a #menuLink
                 [pAutoFocus]="menuItem.autoFocus"
                 role="menuitem"
                 tabindex="0"
                 pRipple
                 class="toolbar-submenu-item gap-2"
                 [attr.aria-label]="i18n?.i18nLng()[menuItem.i18nLabelKey]"
                 (click)="itemClick($event, menuItem)"
                 (keydown.enter)="itemClick($event, menuItem)"
                 (keydown.space)="itemClick($event, menuItem)">
                <i [ngClass]="menuItem.icon"></i>
                <span>{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
              </a>
            </ng-container>
          }
          <div style="height: 1px"></div>
        </li>
      }
    </ul>
  }
</div>
